import { Drawer } from "@mui/material";
import { useMemo, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import {
  ExternalModulesConst,
  ExternalProModulesConst,
  InternalAdminModulesConst,
  InternalUserModulesConst,
} from "consts/ModulesConst";

import LayoutHeaderComponent from "../layout-header/LayoutHeaderComponent";
import LayoutSidebarComponent from "../layout-sidebar/LayoutSidebarComponent";

import "./LayoutComponent.css";
import storage from "services/storage";
import { LayoutComponentProvider } from "./LayoutComponentContext";

const LayoutComponent = ({
  action,
  title: layoutTitle,
  role,
  setRole,
  subscrType,
  setSubscrType,
}) => {
  const [isDrawerExpand, setDrawerExpand] = useState(false);
  const token = storage.getToken();
  const modules = useMemo(
    () =>
      storage.getItem("type") === "ADMIN"
        ? role?.includes("ADMIN")
          ? InternalAdminModulesConst
          : InternalUserModulesConst
        : subscrType === "PRO"
        ? ExternalProModulesConst
        : ExternalModulesConst,
    [subscrType, role],
  );

  const location = useLocation();

  const title = useMemo(() => {
    const currentPageItem =
      modules.find((i) => location.pathname.startsWith(i.path)) || {};

    return currentPageItem.label;
  }, [location, modules]);

  const toggleDrawer = () => {
    setDrawerExpand(!isDrawerExpand);
  };

  return !token ? (
    <Navigate to='/' replace />
  ) : (
    <LayoutComponentProvider setSubscrType={setSubscrType}>
      <div className='layout-container'>
        <LayoutHeaderComponent setRole={setRole} />

        <Drawer
          className='layout-drawer'
          open={isDrawerExpand}
          onClose={toggleDrawer}
          PaperProps={{
            className: "mt-[80px]",
          }}
        >
          <LayoutSidebarComponent isSidebarExpand toggleDrawer={toggleDrawer} />
        </Drawer>

        <LayoutSidebarComponent toggleDrawer={toggleDrawer} />

        <div className='layout-content'>
          <div className='layout-content-inner'>
            <div className='layout-content-inner-header'>
              {layoutTitle ?? (
                <span className='font-bold text-2xl'>{title}</span>
              )}
              {Boolean(action) && (
                <div className='layout-content-inner-header-action'>
                  {action}
                </div>
              )}
            </div>
            <div className='mt-10'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </LayoutComponentProvider>
  );
};

export default LayoutComponent;
